// src/components/AgencyMark.tsx
//
// The Authority's own mark, as it appears on every brand band — the Shell's and
// the sign-in screen's. One component so the two bands cannot drift apart.
//
// The artwork is the Public Service Division mark taken from the Authority's
// own Corrigendum No. 2 document (word/media/image1.png), background made
// transparent, the mark itself untouched — this estate's standing rule is that a
// government mark is never redrawn by hand.
//
// ★ 2026-08-26, by the owner's direction: the mark rides the light plate and
// the ROUNDEL POPS OUT of it. The artwork is served as TWO layers cut from the
// one PNG, pixel for pixel — `psd-roundel.png` is the 139×139 disc (centre
// 100,89 · radius 69.5 in the source's own pixels) and `psd-mark-rest.png` is
// the same 297×176 canvas with those disc pixels removed, so the Prime
// Minister's Office wordmark and the red rule stay where the Authority drew
// them. Recomposed, the two layers differ from the original in ZERO pixels
// (measured). The raised look is CSS lighting on the disc layer alone
// (`.pt-agency-roundel` in styles/index.css); nothing recolours a pixel of
// either.
//
// ⚠ ONE accessible name on the wrapper, both images decorative — two alts would
// read the one mark as two. It names the AGENCY, not the image, and the band's
// adjacent text keeps saying "Public Service Division" for anyone who cannot
// see the mark.
export function AgencyMark(): React.JSX.Element {
  return (
    <span className="pt-agency-mark">
      <span className="pt-agency-artwork" role="img" aria-label="Public Service Division · Prime Minister’s Office">
        <img className="pt-agency-roundel" src="/psd-roundel.png" alt="" width={139} height={139} />
        <span className="pt-agency-roundel-rim" aria-hidden="true" />
        <img className="pt-agency-rest" src="/psd-mark-rest.png" alt="" width={297} height={176} />
      </span>
    </span>
  )
}
